
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'

import COVERAPP from '@/utils/COVERAPP'

@Options({
    data () {
        return {
            listBtnShow: true
        }
    },
    computed: {
        ...mapState(['aid', 'userInfo', 'shareData', 'activityData'])
    },
    mounted () {
        this.$common.track(this.aid, 'load', '首页')
        this.activityData && this.$common.pageLoaded()
        this.shareData.title && this.$common.onshare(this.shareData, this.aid)
    },
    methods: {
        ...mapMutations(['SET_USERINFO', 'SET_DIALOGDATA']),
        goView () {
            this.$common.track(this.aid, 'click', '进入2020') 
            this.$router.push({
                path: '/view'
            })
        },
        goRule () {
            this.$common.track(this.aid, 'click', '活动规则') 
            this.$router.push({
                path: '/rule'
            })
        },
        closeList () {
            this.listBtnShow = false
        },
        goList () {
            this.$common.track(this.aid, 'click', '红包记录')
            if (!COVERAPP.Attribute.isApp()) {
                this.SET_DIALOGDATA({
                    text: '参加该活动需在封面新闻APP中进行',
                    btns: [
                        {
                            text: '确定',
                            className : 'download-btn',
                            data: this.activityData.openApp
                        }
                    ]
                })
                return
            }
            if (this.userInfo.token) {
                this.$router.push({
                    path: '/list'
                })
            } else {
                const _this = this
                COVERAPP.Method.OpenLogin({
                    callback (ret: any) {
                        let userinfo = typeof ret == 'string'.toLowerCase() ? JSON.parse(ret) : ret
                        if (!_this.$common.isEmpty(userinfo.user_id)) {
                            _this.$common.getUser((res: any) => {
                                _this.SET_USERINFO(res)
                                setTimeout(() => {
                                    _this.$router.push({
                                        path: '/list'
                                    })
                                }, 500)
                            })         																													
                        }
                    }
                })
            }
        }
    }
})
export default class Home extends Vue {}
